import React, { useEffect, useState } from "react";
import { ResponsiveBar } from "@nivo/bar";
import axios from "axios";

export default function EnergyClubMonthly() {
  const [data, setData] = useState([]);

  useEffect(() => {
    const fetchMonthly = async () => {
      try {
        const res = await axios.get("http://192.168.0.57:5000/api/energy-club-monthly", {
          params: { club_id: "ENERGYCLUB-0027" },
        });
        console.log("Monthly data:", res.data);
        setData(res.data);
      } catch (err) {
        console.error("Fetch error:", err);
        setData([]);
      }
    };
    fetchMonthly();
  }, []);

  return (
    <div style={{ height: 450, background: "#fff", padding: "25px", margin: "20px", borderRadius: "12px" }}>
      <h3 style={{ textAlign: "center", color: "#333" }}>
        Monthly Submissions — ENERGYCLUB-0027
      </h3>
      {data.length > 0 ? (
        <ResponsiveBar
          data={data}
          keys={["submissions"]}
          indexBy="month"
          margin={{ top: 50, right: 40, bottom: 80, left: 60 }}
          padding={0.3}
          colors={["#36A2EB"]}
          axisBottom={{
            tickRotation: -30,
            legend: "Month",
            legendOffset: 50,
          }}
          axisLeft={{
            legend: "No. of Activities Assigned",
            legendOffset: -40,
          }}
        />
      ) : (
        <p style={{ textAlign: "center" }}>No data available</p>
      )}
    </div>
  );
}
